import React from 'react';
import { RenderModule } from 'holocron';
import { AdData } from '../../../types/PersonalizedMarketingArticles.ts';
import { ADS_MODULE_NAME, MODULE_NAME } from '../../../constants/moduleConstants.ts';

type AdProps = {
  ad: AdData,
  element: string,
  track: any
};

export const Ad = ({
  ad, element, track,
}: AdProps) => (
  <RenderModule
    moduleName={ADS_MODULE_NAME}
    props={{
      placementId: ad?.placementId,
      channelName: ad?.channelName,
      placementName: ad?.placementName,
      onAdEvent: ({ type }: { type: string }) => {
        track({
          event: {
            type,
            element,
            identifier: MODULE_NAME,
          },
        });
      },
    }}
  />
);
